import { useTranslate } from '@tolgee/react';
import { ConfigProvider } from 'antd';
import deDE from 'antd/es/locale/de_DE';
import enUS from 'antd/es/locale/en_US';
import frFR from 'antd/es/locale/fr_FR';
import App from 'antd/lib/app';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import React, { useEffect, useState } from 'react';
import { tolgee } from '../App';
import { FeelEatThemeLight } from '../enums/feeleat-theme';

const ApplicationBranding = ({ children }: { children: React.ReactNode }) => {
  const currentLanguage = tolgee.getLanguage();
  const t = useTranslate();
  const [currentLocale, setCurrentLocale] = useState(enUS);
  useEffect(() => {
    switch (currentLanguage) {
      case 'de':
        setCurrentLocale(deDE);
        dayjs.locale('de');
        break;
      case 'fr':
        setCurrentLocale(frFR);
        dayjs.locale('fr');
        break;
      default:
        setCurrentLocale(enUS);
        dayjs.locale('en');
    }
  }, [currentLanguage]);
  return (
    <ConfigProvider theme={FeelEatThemeLight} locale={currentLocale}>
      <App>{children}</App>
    </ConfigProvider>
  );
};

export default ApplicationBranding;
